function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB4437"
    },
    d: "M155.217,314.173L256,139.621l18.717,0.321l30.593,1.179l102.195,35.376l76.571-36.876 C441.7,56.74,355.477,0,256,0C165.638,0,86.216,46.821,40.657,117.523v0.172l7.746,131.034L155.217,314.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F9D58"
    },
    d: "M155.217,314.173L40.657,117.695l-0.053-0.091C14.911,157.509,0,205.012,0,256 c0,137.319,108.12,249.374,243.873,255.707l91.484-60.672l21.407-136.828L155.217,314.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD40"
    },
    d: "M484.076,139.621H256l100.783,174.552l-0.019,0.034l-112.891,197.5 c0.03,0.001,0.059,0.002,0.089,0.003c3.991,0.185,8.002,0.29,12.039,0.29c141.385,0,256-114.615,256-256 C512,214.092,501.928,174.537,484.076,139.621z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F1F1F1"
    },
    cx: 256,
    cy: 256,
    r: 116.379
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4285F4"
    },
    cx: 256,
    cy: 256,
    r: 93.103
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.3adfa8695dcdb61633540a1224503af5.svg";
export { ForwardRef as ReactComponent };